import React from 'react'
import { Link } from 'react-router-dom';

function Feature() {
  const gototop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
  return (
    <>
      <section>
        <div class="container">
          <div
            class="row justify-content-between align-items-center mb-4 mb-lg-5"
          >
            <div class="col-lg-6 col-md-5">
              <div>
                <h2>
                  <span class="font-w-4 d-block me-2">Effortless Process in</span>
                  Three Simple Steps
                </h2>
              </div>
            </div>
            {/* <div class="col-lg-4 col-12 text-center">              
              <Link className="btn btn-dark" to="quotation">Order Your Inspection</Link>
            </div> */}
          </div>
          <div class="row mt-lg-n5 align-items-center">
            <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
              <div class="p-5 feature-hover active position-relative">
                <div class="f-icon">
                  <img src={require("../../assets/icon/order.webp")} width={60} alt="Order Inspection" />
                  {/* <i class="flaticon-prototype"></i> */}
                </div>
                <h5 class="mt-4 mb-3">Order Inspection</h5>
                <p class="mb-0">
                  You can easily place an inspection order through our website or by calling our team to complete it over the phone.
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
              <div class="p-5 feature-hover active position-relative">
                <div class="f-icon">
                  <img src={require("../../assets/icon/inspection.webp")} width={60} alt="Expert Inspection Process" />
                  {/* <i class="flaticon-knowledge"></i> */}
                </div>
                <h5 class="mt-4 mb-3">Expert Inspection Process</h5>
                <p class="mb-0">
                  Our ASE certified inspector contacts your seller, arranges an inspection appointment, and performs a comprehensive on-site examination.
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
              <div class="p-5 feature-hover active position-relative">
                <div class="f-icon">
                  <img src={require("../../assets/icon/access.webp")} width={60} alt="Access Your Report" />
                  {/* <i class="flaticon-data-analytics"></i> */}
                </div>
                <h5 class="mt-4 mb-3">Access Your Report</h5>
                <p class="mb-0">
                  The inspector completes the report on-site. After a thorough review and error checking process, you’ll receive an email with a link to access your report.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  )
}

export default Feature
